<template>
    <b-form-group
        :state="isValid"
        :invalid-feedback="invalidFeedback"
        :description="helpText"
        class="pt-1"
    >
        <label class="form-label mr-2" :class="{'mb-1': !inline}" :for="fieldId">
            {{ fieldLabel }}: <slot></slot>
        </label>
        <span class="several" v-if="several"> (Varios pueden ser elegidos)</span>
        <br v-if="!inline">
        <div
            v-for="(option, index) in options"
            :key="fieldId  + '-' + index"
            :id="fieldId  + '-' + index"
            :class="{'selected': isSelected(option.value)}"
            class="select-option"
            @click="clicked(option.value)"
        >
            {{ option.display_name }}
        </div>

    </b-form-group>
</template>

<script>
    import fieldMixin from "@/components/fields/FieldMixin";
    import {capitalizeFilter, isNull} from "@/utils/formatting";

    export default {
        name: "SelectAsRadioField",
        mixins: [fieldMixin],
        props: {
            choices: {
                type: Array,
            },
            several: {
                type: Boolean,
                default: false,
            },
            yesNo: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            options() {
                if (this.yesNo) {
                    return [
                        {display_name: capitalizeFilter(this.$t('utils.yes')), value: true},
                        {display_name: capitalizeFilter(this.$t('utils.no')), value: false},
                    ];
                }
                return !isNull(this.choices) ? this.choices : this.field.choices;
            },
        },
        methods: {
            clicked(newValue) {
                if (this.several) {
                    this.emitMultipleValues(newValue);
                } else {
                    this.emitSingleValue(newValue);
                }
            },
            emitSingleValue(newValue) {
                if (newValue !== this.value) {
                    this.changeValue(newValue);
                } else {
                    this.changeValue("");
                }
            },
            emitMultipleValues(newValue) {
                if (isNull(this.value) && this.value !== '') {
                    this.changeValue([newValue]);
                    return;
                }
                if (this.value.indexOf(newValue) === -1) {
                    const existingArray = this.value || [];
                    this.changeValue([...existingArray, newValue]);
                } else {
                    this.changeValue(this.value.filter(element => element !== newValue));
                }
            },
            isSelected(value) {
                if (this.several) {
                    return !isNull(this.value) && this.value !== '' && this.value.indexOf(value) !== -1;
                }
                return this.value === value;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "src/custom";

    $selected: white;
    $selected-bg: $primary;
    $unselected: #B1B1B4;
    $unselected-bg: #F3F1EF;

    .several {
        color: $unselected;
        font-size: 0.9rem;
    }

    .select-option {
        @extend .py-0;
        @extend .px-2;
        @extend .mr-2;
        @extend .mb-2;
        @extend .d-inline-block;

        color: $unselected;
        background-color: $unselected-bg;
        cursor: pointer;

        &:hover {
            background-color: adjust-color($unselected, $lightness: 10%);
            color: white;
        }

        &.selected {
            color: $selected;
            background-color: $selected-bg;
        }
    }

</style>